import { render, staticRenderFns } from "./BindPhone_Mingyu.vue?vue&type=template&id=5dfd8502"
import script from "./BindPhone_Mingyu.vue?vue&type=script&lang=js"
export * from "./BindPhone_Mingyu.vue?vue&type=script&lang=js"
import style0 from "./BindPhone_Mingyu.vue?vue&type=style&index=0&id=5dfd8502&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports